import dayjs from "dayjs";
import { Card, Col, Row } from "react-bootstrap";
var isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)


export default function CartaFaseIniziativa(props) {

    const getColoreFase = () => {
        let inizioFase = dayjs(props.fase.finiDataInizio)
        let fineFase = dayjs(props.fase.finiDataFine)
        if (dayjs().isBetween(inizioFase, fineFase, null, [])) {
            return "success"
        } else {
            return "muted"
        }
    }

    return (
        <Card className="cartaSommario shadow mt-4" border={getColoreFase()}>
            <Card.Body>
                <span className="smallText smallCaps ">Fase {props.fase.finiOrdine}</span>
                <h5> <strong>{props.fase.finiTitolo}</strong></h5>
                <p className="smallText">{props.fase.finiDescrizione}</p>
                {props.fase.finiFlInvioProgetti &&
                    <p> Puoi <strong>pubblicare progetti</strong>. </p>
                }
                <Row>
                    <Col>{dayjs(props.fase.finiDataInizio).format('DD/MM/YYYY')}</Col>
                    <Col className="text-end">{dayjs(props.fase.finiDataFine).format('DD/MM/YYYY')}</Col>
                </Row>
            </Card.Body>
        </Card>
    )
}